// extracted by mini-css-extract-plugin
module.exports = {"content":"ChipsSelect_content__3-W3N","options":"ChipsSelect_options__2haWr","option":"ChipsSelect_option__1xqbu","selected":"ChipsSelect_selected__ouD1B"};